<template>
    <titan-form :schema="schema"
                :newItem="false"
                :model="dataItem"
                v-on:saveData="saveData()"
    />
</template>
<script>
    import TitanForm from '../../../../core/Form/Form'
    import VueFormGenerator from "vue-form-generator";

    export default {
        components: {
            TitanForm,
        },
        methods: {
            saveData() {
                this.$store.dispatch('users/changePassword', this.dataItem).then(response => {
                    this.$store.dispatch('alert/success', 'Password was changed');
                }).catch(error => {
                    this.$store.dispatch('alert/warning', error.data.status);
                });
            }
        },
        data() {
            return {
                dataItem: {
                    id: this.$route.params.id,
                    newPassword: '',
                    newPasswordAgain: '',
                },
                schema: [
                    {
                        name: this.t('Change password'),
                        type: 'main',
                        fields: [
                            {
                                type: 'input',
                                inputType: 'password',
                                label: this.t('New password'),
                                model: 'newPassword',
                                required: true,
                                min: 6,
                                validator: VueFormGenerator.validators.string
                            }, {
                                type: 'input',
                                inputType: 'password',
                                label: this.t('New password (again)'),
                                model: 'newPasswordAgain',
                                required: true,
                                min: 6,
                                validator: (value, field, model) => {
                                    if (model.newPassword !== model.newPasswordAgain) {
                                        return [this.t('New password fields must be equal.')];
                                    }
                                    return VueFormGenerator.validators.required(value, field, model);
                                }
                            }
                        ]
                    }
                ]
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/users/manage/ChangePassword.vue